<script>
  import { Line } from 'vue-chartjs'
  import Colors from '../../mixins/Colors'
  import moment from 'moment-es6'
  import { mapState, mapMutations } from 'vuex'
  import { DASHBOARD_CHARTS_CACHED, DASHBOARD_CHARTS_NOT_CACHED } from '../../store/mutation-types'

  export default {
    name: 'DashboardLineGraph',
    extends: Line,
    props: {
      graph: {
        type: Object,
        required: true
      },
      graphData: {
        type: Object,
        required: true
      },
      chartUpdated: {
        type: Boolean
      },
      updatedId: {
        type: Number
      }
    },
    mixins: [Colors],
    data () {
      return {
        chartData: {},
        chartOptions: {},
        initiallyRendered: false
      }
    },
    computed: {
      ...mapState({
        chartsCached: state => state.dashboard.chartsCached
      })
    },
    methods: {
      ...mapMutations({
        cacheCharts: DASHBOARD_CHARTS_CACHED,
        unCacheCharts: DASHBOARD_CHARTS_NOT_CACHED
      }),
      noDataRender () {
        this.drawGraphInfo(this.graph)
        this.defaultDataSet()
        this.renderChart(this.chartData, this.chartOptions)
      },
      isMyGraphData () {
        return this.graphData.id === this.graph.id
      },
      renderData () {
        this.setInitialRender()
        // Destroy any existing graph
        this.destroyChart()
        // Reset DataSet before drawing
        this.defaultDataSet()
        // Draw axis/labels
        this.drawGraphInfo(this.graph)

        if (this.graphData.chartData && this.isMyGraphData()) {
          this.chartData.datasets = this.drawDataSets(this.graphData)
        }
        this.renderChart(this.chartData, this.chartOptions)

        // cache charts after render so charts won't animate the next time
        this.cacheCharts()
      },
      defaultDataSet () {
        this.chartData.datasets = []
      },
      drawGraphInfo (graph) {
        this.chartData.labels = graph.chartLabels.map(res => moment(parseInt(res)).format('DD/MM'))

        let animation = this.chartsCached ? {duration: 0} : {duration: 400}
        this.chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 10,
              right: 10,
              top: 0,
              bottom: 10
            }
          },
          animation,
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: true
                },
                distribution: 'linear'
              }
            ],
            yAxes: [
              {
                display: true,
                gridLines: {
                  display: true
                },
                distribution: 'linear'
              }
            ]},
          tooltips: {
            mode: 'index',
            intersect: false
          }
        }
      },
      setInitialRender () {
        this.initiallyRendered = true
      },
      destroyChart () {
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
      },
      makeAxis (source, label, colour) {
        return {
          label: label,
          fill: false,
          data: source,
          borderColor: colour,
          backgroundColor: colour
        }
      },
      drawDataSets (graph) {
        let obj = []
        for (let i = 0; i < graph.chartData.length; i++) {
          obj.push(this.makeAxis(graph.chartData[i].data.map(res => res.chartValue), graph.chartData[i].identifier, this.drawColours(graph, i)))
        }
        return obj
      },
      drawColours (graph, i) {
        return graph.chartData[i].colour
          ? graph.chartData[i].colour
          : this.chartColors[i]
      }
    },
    watch: {
      graphData () {
        this.renderData()
      },
      chartUpdated (value) {
        if (value) {
          // un-cache so we can animate charts
          this.unCacheCharts()
          this.renderData()
        }
      }
    },
    mounted () {
      this.noDataRender()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardLineGraph.vue